import { render, staticRenderFns } from "./FormattedBalance.vue?vue&type=template&id=0aeafdba&scoped=true&"
import script from "./FormattedBalance.vue?vue&type=script&lang=js&"
export * from "./FormattedBalance.vue?vue&type=script&lang=js&"
import style0 from "./FormattedBalance.vue?vue&type=style&index=0&id=0aeafdba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aeafdba",
  null
  
)

export default component.exports